import { render, staticRenderFns } from "./DashboardInvestor.vue?vue&type=template&id=e9acc798"
import script from "./DashboardInvestor.vue?vue&type=script&lang=js"
export * from "./DashboardInvestor.vue?vue&type=script&lang=js"
import style0 from "./DashboardInvestor.vue?vue&type=style&index=0&id=e9acc798&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports